import {
  useActiveVkuiLocation,
  useFirstPageCheck,
  useRouteNavigator,
} from '@vkontakte/vk-mini-apps-router';
import { VIEW, VIEW_ROOT_PATH, type ViewId } from './router';

/**
 * Возврат, которому всегда есть куда вернуться.
 *
 * `routeNavigator.back()` — это шаг по стеку РОУТЕРА, а стек у свежего
 * документа пуст: приложение, открытое сразу на внутреннем экране, получало
 * кнопку возврата, которая не делает ничего. Случай не редкий — прямая ссылка
 * на разбор заявки, перезагрузка страницы (в разработке это каждая правка
 * кода), возврат в мини-приложение по сохранённому адресу.
 *
 * Возвращаться некуда — уходим в корень ТЕКУЩЕЙ вкладки: из разбора заявки в
 * очередь, из редактора анкеты в карточку персонажа, из чужого досье в реестр.
 * Экраны своего «куда» не называют: вкладка и есть ответ, а записанный на
 * каждом экране адрес разъехался бы с маршрутами на первой же правке.
 *
 * `replace`, а не `push`: шага назад не было, и заводить его задним числом
 * значит оставить позади экран, на который человек не приходил.
 */
export function useBack(): () => void {
  const routeNavigator = useRouteNavigator();
  const isFirstPage = useFirstPageCheck();
  const { view } = useActiveVkuiLocation();

  return () => {
    if (!isFirstPage) {
      routeNavigator.back();
      return;
    }

    routeNavigator.replace(VIEW_ROOT_PATH[(view ?? VIEW.REGISTRY) as ViewId]);
  };
}
